import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useProductBasicDetails from '../useProductBasicDetails';
const GET_IS_MODULAR_BUNDLE_PRODUCT = gql`
  query getIsModularBundleOrPreconfigProduct($id: Int) {
    getIsModularBundleOrPreconfigProduct(id: $id) {
      productType
      isInModular
    }
  }
`;

// Keep this separate from the configurator's GET_MODULAR_SOFA_BUNDLE, which
// carries photos and reviews for every preconfig and runs to about 5 MB. The
// consumers here only need the parent slug and id/slug/name (CON-8446).
const GET_MODULAR_SOFA_BUNDLE_SUMMARY = gql`
  query getModularSofaBundleSummary($slug: String) {
    modularBundle: getModularSofaBundle(slug: $slug) {
      modular_parent {
        slug
      }
      preConfiguredProducts {
        id
        slug
        name
      }
    }
  }
`;
const useModularDetails = t0 => {
  const $ = _c(32);
  const slug = t0 === undefined ? null : t0;
  const {
    loading: productBasicLoading,
    error: productBasicError,
    data: t1
  } = useProductBasicDetails(null, slug);
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const productBasicData = t2;
  const t3 = productBasicData?.id;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      id: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !productBasicData?.id;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      noBatch: true
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t5) {
    t7 = {
      variables: t4,
      skip: t5,
      context: t6
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const {
    data,
    error,
    loading
  } = useSuspenseQuery(GET_IS_MODULAR_BUNDLE_PRODUCT, t7);
  const [getModularBundleData, t8] = useLazyQuery(GET_MODULAR_SOFA_BUNDLE_SUMMARY);
  const {
    data: modularBundleData,
    called: modularBundleCalled,
    loading: modularBundleLoading
  } = t8;
  let t9;
  if ($[8] !== data?.getIsModularBundleOrPreconfigProduct?.isInModular || $[9] !== getModularBundleData || $[10] !== modularBundleData?.modularBundle?.modular_parent?.slug || $[11] !== productBasicData) {
    t9 = () => {
      if (!productBasicData?.slug || !data?.getIsModularBundleOrPreconfigProduct?.isInModular) {
        return;
      }
      const finalSlug = productBasicData.meta.collectionSlug ? productBasicData.meta.collectionSlug.replace("collections/", "") : null;
      if (!finalSlug || (modularBundleData?.modularBundle?.modular_parent?.slug || "").includes(finalSlug)) {
        return;
      }
      getModularBundleData({
        variables: {
          slug: `${finalSlug}-modular`
        }
      });
    };
    $[8] = data?.getIsModularBundleOrPreconfigProduct?.isInModular;
    $[9] = getModularBundleData;
    $[10] = modularBundleData?.modularBundle?.modular_parent?.slug;
    $[11] = productBasicData;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = data?.getIsModularBundleOrPreconfigProduct?.isInModular;
  const t11 = productBasicData?.meta;
  const t12 = productBasicData?.slug;
  let t13;
  if ($[13] !== getModularBundleData || $[14] !== modularBundleData || $[15] !== t10 || $[16] !== t11 || $[17] !== t12) {
    t13 = [t10, t11, modularBundleData, getModularBundleData, t12];
    $[13] = getModularBundleData;
    $[14] = modularBundleData;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  useEffect(t9, t13);
  const isInModular = data?.getIsModularBundleOrPreconfigProduct?.isInModular;
  let t14;
  if ($[19] !== productBasicData?.meta?.collectionSlug || $[20] !== productBasicData?.slug) {
    t14 = !!productBasicData?.slug && !!(productBasicData?.meta?.collectionSlug || "").replace("collections/", "");
    $[19] = productBasicData?.meta?.collectionSlug;
    $[20] = productBasicData?.slug;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const canQueryBundle = t14;
  const preConfigProductsSettled = !isInModular || !canQueryBundle || modularBundleCalled && !modularBundleLoading;
  const t15 = productBasicLoading || loading;
  const t16 = productBasicError || error;
  const t17 = data?.getIsModularBundleOrPreconfigProduct?.productType === "Bundle";
  const t18 = data?.getIsModularBundleOrPreconfigProduct?.productType === "Preconfig";
  const t19 = modularBundleData?.modularBundle?.preConfiguredProducts;
  let t20;
  if ($[22] !== isInModular || $[23] !== t17 || $[24] !== t18 || $[25] !== t19) {
    t20 = {
      isModular: isInModular,
      isModularBundleProduct: t17,
      isModularPreConfigProduct: t18,
      preConfigProducts: t19
    };
    $[22] = isInModular;
    $[23] = t17;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== preConfigProductsSettled || $[28] !== t15 || $[29] !== t16 || $[30] !== t20) {
    t21 = {
      loading: t15,
      error: t16,
      preConfigProductsSettled,
      data: t20
    };
    $[27] = preConfigProductsSettled;
    $[28] = t15;
    $[29] = t16;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  return t21;
};
export default useModularDetails;